import { client } from './base'

export const getRegistrationOptions = async (token: string) =>
  await client.post('/api/webauthn/register/options', { token })

export const registerCredential = async (token: string, credential: any) =>
  await client.post('/api/webauthn/register', { token, credential })

export const getAuthenticationOptions = async (token: string) =>
  await client.post('/api/webauthn/authenticate/options', { token })

export const authenticateCredential = async (token: string, assertion: any) =>
  await client.post('/api/webauthn/authenticate', { token, assertion })
